import React from 'react';

import { Flex } from '@chakra-ui/react';

export const HeaderRightAction = (props) => (
  <Flex
    h="100%"
    position="absolute"
    alignItems="center"
    right={2}
    zIndex="3"
    {...props}
  />
);
